module.exports = [
  {
    id: 205581922,
    name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
    brandId: 53,
    brandName: "ASOS DESIGN",
    images: [
      {
        url: "https://images.asos-media.com/products/asos-design-wide-fit-lottie-mary-jane-ballet-in-black/205581922-1-black",
        type: "Standard1",
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
      },
    ],
    sizeGuide:
      "https://www.asos.com/web/pages/size-guides/index.html?sizeSchema=UK&x-site-origin=e2e01.asosdevelopment.com&data=https://www.asos.com/api/sizing/sizeapi/v1/SizeGuide/3839%3flanguage%3den-GB",
    isNoSize: false,
    isOneSize: false,
    isAvailable: true,
    isInStock: true,
    productCode: "133360006",
    colour: "BLACK",
    shippingRestriction: {
      includedCountryCodes: [
        "AD",
        "AE",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BW",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SZ",
        "TC",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UG",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "YT",
        "ZA",
        "ZM",
        "ZW",
      ],
      excludedCountryCodes: [],
    },
    variants: [
      {
        variantId: 205581924,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396089,
        size: "UK 7",
        sizeOrder: 6,
        sku: "133360015",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581925,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396093,
        size: "UK 4",
        sizeOrder: 3,
        sku: "133360018",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581926,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396094,
        size: "UK 9",
        sizeOrder: 8,
        sku: "133360014",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581927,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396096,
        size: "UK 3",
        sizeOrder: 2,
        sku: "133360016",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581928,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396091,
        size: "UK 2",
        sizeOrder: 1,
        sku: "133360012",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581929,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396092,
        size: "UK 5",
        sizeOrder: 4,
        sku: "133360010",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581930,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 407820,
        size: "UK 10",
        sizeOrder: 9,
        sku: "133360011",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581931,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396090,
        size: "UK 8",
        sizeOrder: 7,
        sku: "133360017",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581932,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 408730,
        size: "UK 11",
        sizeOrder: 10,
        sku: "133360019",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
      {
        variantId: 205581933,
        name: "ASOS DESIGN Wide Fit Lottie Mary Jane Ballet in black",
        sizeId: 396095,
        size: "UK 6",
        sizeOrder: 5,
        sku: "133360013",
        isAvailable: true,
        colourWayId: 205581923,
        colour: "BLACK",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£20.00" },
          previous: { text: "£20.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
    ],
    isHazmat: false,
    earlyAccess: null,
    price: {
      current: { text: "£20.00" },
      previous: { text: "£20.00" },
      rrp: { text: null },
    },
    restockingSoonDetails: {
      isRestockingSoon: false,
    },
  },
  {
    id: 205687926,
    name: "Reclaimed Vintage 90s oval sunglasses in brown",
    brandId: 12769,
    brandName: "Reclaimed Vintage",
    images: [
      {
        url: "https://images.asos-media.com/products/reclaimed-vintage-90s-oval-sunglasses-in-brown/205687926-1-brown",
        type: "Standard1",
        colourWayId: 205687930,
        colour: "BROWN",
        isPrimary: true,
      },
    ],
    sizeGuide:
      "https://www.asos.com/web/pages/size-guides/index.html?sizeSchema=UK&x-site-origin=e2e01.asosdevelopment.com&data=https://www.asos.com/api/sizing/sizeapi/v1/SizeGuide/1265%3flanguage%3den-GB",
    isNoSize: false,
    isOneSize: true,
    isAvailable: true,
    isInStock: true,
    productCode: "133546802",
    colour: "BROWN",
    shippingRestriction: {
      includedCountryCodes: [
        "AD",
        "AE",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BW",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SZ",
        "TC",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UG",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "YT",
        "ZA",
        "ZM",
        "ZW",
      ],
      excludedCountryCodes: [],
    },
    variants: [
      {
        variantId: 205687931,
        name: "Reclaimed Vintage 90s oval sunglasses in brown",
        sizeId: 578048,
        size: "One Size",
        sizeOrder: 10,
        sku: "133546806",
        isAvailable: true,
        colourWayId: 205687930,
        colour: "BROWN",
        isPrimary: true,
        ean: null,
        countryOfManufacture: "China",
        price: {
          current: { text: "£12.99" },
          previous: { text: "£12.99" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
    ],
    isHazmat: false,
    earlyAccess: null,
    price: {
      current: { text: "£12.99" },
      previous: { text: "£12.99" },
      rrp: { text: null },
    },
    restockingSoonDetails: {
      isRestockingSoon: false,
    },
  },
  {
    id: 205770138,
    name: "Glamorous pocket detail shoulder bag in washed brown",
    brandId: 13138,
    brandName: "Glamorous",
    images: [
      {
        url: "https://images.asos-media.com/products/glamorous-pocket-detail-shoulder-bag-in-washed-brown/205770138-1-brown",
        type: "Standard1",
        colourWayId: 205770139,
        colour: "BROWN",
        isPrimary: true,
      },
    ],
    sizeGuide:
      "https://www.asos.com/web/pages/size-guides/index.html?sizeSchema=UK&x-site-origin=e2e01.asosdevelopment.com&data=https://www.asos.com/api/sizing/sizeapi/v1/SizeGuide/3041%3flanguage%3den-GB",
    isNoSize: true,
    isOneSize: false,
    isAvailable: true,
    isInStock: true,
    productCode: "133691021",
    colour: "BROWN",
    shippingRestriction: {
      includedCountryCodes: [
        "AD",
        "AE",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BW",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SZ",
        "TC",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UG",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "YT",
        "ZA",
        "ZM",
        "ZW",
      ],
      excludedCountryCodes: [],
    },
    variants: [
      {
        variantId: 205770140,
        name: "Glamorous pocket detail shoulder bag in washed brown",
        sizeId: 396978,
        brandSize: "No Size",
        size: "No Size",
        sizeOrder: 10,
        sku: "133691053",
        isAvailable: true,
        colourWayId: 205770139,
        colour: "BROWN",
        isPrimary: true,
        ean: "5063343097064",
        countryOfManufacture: "China",
        price: {
          current: { text: "£26.00" },
          previous: { text: "£26.00" },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
    ],
    isHazmat: false,
    earlyAccess: null,
    price: {
      current: { text: "£26.00" },
      previous: { text: "£26.00" },
      rrp: { text: null },
    },
    restockingSoonDetails: {
      isRestockingSoon: false,
    },
  },
  {
    id: 205704027,
    name: "DesignB London oversized organza scrunchie with stitch detail in taupe",
    brandId: 14969,
    brandName: "DesignB London",
    images: [
      {
        url: "https://images.asos-media.com/products/designb-london-oversized-organza-scrunchie-with-stitch-detail-in-taupe/205704027-1-taupe",
        type: "Standard1",
        colourWayId: 205704028,
        colour: "Taupe",
        isPrimary: true,
      },
    ],
    sizeGuide:
      "https://www.asos.com/web/pages/size-guides/index.html?sizeSchema=UK&x-site-origin=e2e01.asosdevelopment.com&data=https://www.asos.com/api/sizing/sizeapi/v1/SizeGuide/3041%3flanguage%3den-GB",
    isNoSize: true,
    isOneSize: false,
    isAvailable: true,
    isInStock: false,
    productCode: "133574247",
    colour: "Taupe",
    shippingRestriction: {
      includedCountryCodes: [
        "AD",
        "AE",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BW",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SZ",
        "TC",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UG",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "YT",
        "ZA",
        "ZM",
        "ZW",
      ],
      excludedCountryCodes: ["LI", "CH"],
    },
    variants: [
      {
        variantId: 205704029,
        name: "DesignB London oversized organza scrunchie with stitch detail in taupe",
        sizeId: 560107,
        brandSize: "No Size",
        size: "No Size",
        sizeOrder: 10,
        sku: "133574250",
        isAvailable: true,
        colourWayId: 205704028,
        colour: "Taupe",
        isPrimary: true,
        ean: null,
        countryOfManufacture: "China",
        price: {
          current: { text: "£6.00" },
          previous: { text: "£6.00" },
          rrp: { text: null },
        },
        isInStock: false,
        hasIngredients: false,
        isLowInStock: false,
        seller: null,
        source: null,
      },
    ],
    isHazmat: false,
    earlyAccess: null,
    price: {
      current: { text: "£6.00" },
      previous: { text: "£6.00" },
      rrp: { text: null },
    },
    restockingSoonDetails: {
      isRestockingSoon: false,
    },
  },
  {
    id: 206896752,
    name: "adidas Originals Classics track pants in light blue",
    brandId: 17,
    brandName: "adidas Originals",
    images: [
      {
        url: "https://images.asos-media.com/products/adidas-originals-classics-track-pants-in-light-blue/208422506-1-clearskynightindigo",
        type: "Standard1",
        colourWayId: 206896753,
        colour: "LIGHT BLUE",
        isPrimary: true,
      },
    ],
    sizeGuide:
      "https://www.asos.com/web/pages/size-guides/index.html?sizeSchema=UK&x-site-origin=e2e01.asosdevelopment.com&data=https://www.asos.com/api/sizing/sizeapi/v1/SizeGuide/4395?language=en-GB",
    isNoSize: false,
    isOneSize: false,
    isAvailable: true,
    isInStock: true,
    productCode: "135639583",
    colour: "LIGHT BLUE",
    shippingRestriction: {
      includedCountryCodes: [
        "AD",
        "AE",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BW",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SZ",
        "TC",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UG",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "YT",
        "ZA",
        "ZM",
        "ZW",
      ],
      excludedCountryCodes: [],
    },
    variants: [
      {
        variantId: 206896754,
        name: "adidas Originals Classics track pants in light blue",
        sizeId: 501001,
        size: "UK XS",
        sizeOrder: 1,
        sku: "135639583-XS",
        isAvailable: true,
        colourWayId: 206896753,
        colour: "LIGHT BLUE",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£60.00" },
          previous: { text: null },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: { id: "ADD", description: "adidas" },
        source: { id: "ADD", description: "adidas" },
      },
      {
        variantId: 206896755,
        name: "adidas Originals Classics track pants in light blue",
        sizeId: 501002,
        size: "UK S",
        sizeOrder: 2,
        sku: "135639583-S",
        isAvailable: true,
        colourWayId: 206896753,
        colour: "LIGHT BLUE",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£60.00" },
          previous: { text: null },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: { id: "ADD", description: "adidas" },
        source: { id: "ADD", description: "adidas" },
      },
      {
        variantId: 206896756,
        name: "adidas Originals Classics track pants in light blue",
        sizeId: 501003,
        size: "UK M",
        sizeOrder: 3,
        sku: "135639583-M",
        isAvailable: true,
        colourWayId: 206896753,
        colour: "LIGHT BLUE",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£60.00" },
          previous: { text: null },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: { id: "ADD", description: "adidas" },
        source: { id: "ADD", description: "adidas" },
      },
      {
        variantId: 206896757,
        name: "adidas Originals Classics track pants in light blue",
        sizeId: 501004,
        size: "UK L",
        sizeOrder: 4,
        sku: "135639583-L",
        isAvailable: true,
        colourWayId: 206896753,
        colour: "LIGHT BLUE",
        isPrimary: true,
        ean: null,
        price: {
          current: { text: "£60.00" },
          previous: { text: null },
          rrp: { text: null },
        },
        isInStock: true,
        hasIngredients: false,
        isLowInStock: false,
        seller: { id: "ADD", description: "adidas" },
        source: { id: "ADD", description: "adidas" },
      },
    ],
    isHazmat: false,
    earlyAccess: null,
    price: {
      current: { text: "£60.00" },
      previous: { text: null },
      rrp: { text: null },
    },
    restockingSoonDetails: {
      isRestockingSoon: false,
    },
  },
];
